
import { forwardRef, useState, useEffect } from 'react';

const images = [
  { src: '/cesitli-tatlilar-2.png', alt: 'Çeşitli Tatlılar' },
  { src: '/kruvasan.png', alt: 'Taze Kruvasanlar' },
  { src: '/cesitli-tatlilar-3.png', alt: 'Çeşitli Tatlılar' }
];

const About = forwardRef<HTMLElement>((props, ref) => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => {
        const next = (prev + 1) % images.length;
        return next;
      });
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, [images.length]);

  return (
    <section
      id="about"
      ref={ref}
      className="py-16 px-[6%] flex items-center opacity-0 transition-all duration-1000 bg-gradient-to-br from-[#F5EDE4] via-[#EDE4D8] to-[#E8DFD3]"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 w-full items-center max-w-7xl mx-auto">
        {/* Left content */}
        <div className="space-y-6">
          <div className="transform transition-all duration-800">
            <h2 className="font-cormorant text-4xl lg:text-5xl text-[#1A365D] leading-tight mb-8">
              Arnavutköy'ün<br />
              Butik Lezzet Durağı
            </h2>
          </div>

          <div className="space-y-4 text-[#4A5568] text-base leading-relaxed">
            <p>
              Mavi Patisserie, geleneksel dünya pastacılık sanatını mavi dokunuşuyla harmanlayarak, her gün taze ve el yapımı lezzetler sunuyor.
            </p>
            <p>
              Ustamız, en kaliteli malzemeleri özenle seçerek, her tatlıyı bir sanat eserine dönüştürüyor. Sabahın erken saatlerinde başlayan üretimimiz, size en taze ve lezzetli ürünleri sunmayı garanti ediyor.
            </p>
            <p>
              Butik pastane anlayışımızla, her müşterimize samimi ve kaliteli bir hizmet sunuyoruz. Küçük ama özenli işletmemizde lezzet ve kalite bir arada.
            </p>
          </div>
        </div>

        {/* Right image - daha büyük */}
        <div className="transform transition-all duration-1000">
          <div className="relative">
            {/* Decorative frame with image slider */}
            <div className="border-3 border-[#D4AF37] rounded-2xl overflow-hidden relative shadow-2xl">
              <div className="relative aspect-[4/3]">
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                      index === currentImage ? 'opacity-100' : 'opacity-0'
                    }`}
                  />
                ))}
              </div>
              {/* Decorative rosette */}
              <div className="absolute -top-3 -right-3 w-14 h-14 bg-[#1A365D] border-2 border-[#D4AF37] rounded-full flex items-center justify-center shadow-lg z-10">
                <i className="ri-star-fill text-[#D4AF37] text-xl"></i>
              </div>
              {/* Slide indicators */}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImage(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      index === currentImage
                        ? 'bg-[#D4AF37] w-6'
                        : 'bg-white/50 hover:bg-white/80'
                    }`}
                    aria-label={`Görsel ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

About.displayName = 'About';

export default About;
